import { Box, Button, Container } from "@mui/material";

import { HeroText } from "components/shared/Typography";
import { IDT_REQUEST_CONSULTATION } from "helpers/constants";

export const GetQuote = () => (
  <Box
    component="section"
    pt={{ xs: 4, md: 5, lg: 10 }}
    pb={{ xs: 5, md: 7, lg: 12 }}
    className="default-bg"
  >
    <Container>
      <HeroText align="center" display="block" component="h2">
        Ready to start
      </HeroText>
      <Box mt={4} display="flex" width={1} justifyContent="center">
        <Button
          size="large"
          onClick={(event: React.MouseEvent<HTMLElement>) =>
            window.open(IDT_REQUEST_CONSULTATION, "_blank")
          }
        >
          Get a quote
        </Button>
      </Box>
    </Container>
  </Box>
);
